import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-gnp',
  templateUrl: './loader-gnp.component.html',
  styleUrls: ['./loader-gnp.component.scss']
})
export class LoaderGnpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
